import StoredLayout from '../../layouts/StoredLayout'
import BarChartWidgets from './BarChartWidgets'
export default StoredLayout(BarChartWidgets)



// WEBPACK FOOTER //
// ./src/widgets/bar-chart-widgets/index.js